import React from 'react';
import { NavLink } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';

interface MobileNavigationProps {
    isMenuOpen: boolean;
    setIsMenuOpen: (isOpen: boolean) => void;
    isScrolled: boolean;
    isHomePage: boolean;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({ isMenuOpen, setIsMenuOpen, isScrolled, isHomePage }) => {
    return (
        <div className="lg:hidden flex items-center relative">
            <button
                className={`text-2xl cursor-pointer transform transition-transform duration-500 ${isMenuOpen ? 'rotate-90' : 'rotate-0'}`}
                style={{ color: isScrolled ? '#273167' : isHomePage ? 'white' : '#273167' }}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
                ☰
            </button>

            {/* Затемнение фона и меню с анимацией */}
            {isMenuOpen && (
                <div
                    className={`fixed inset-0 bg-black ${isMenuOpen?'bg-opacity-50':'bg-opacity-0'} transform transition-all h-screen duration-500`}
                    onClick={() => setIsMenuOpen(false)}
                />
            )}

            {/* Меню с анимацией и выравниванием по правому краю */}
            <div
                className={`fixed top-0 right-0 w-full bg-white  flex flex-col items-end shadow-xl transform transition-transform duration-500 ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
            >
                {/* Кнопка закрытия меню с анимацией */}
                <CloseIcon
                    sx={{ fontSize: 30, color: '#273167' }}
                    className={`my-4 cursor-pointer mx-5 transform transition-transform duration-500 ${isMenuOpen ? 'rotate-0' : '-rotate-90'}`}
                    onClick={() => setIsMenuOpen(false)}
                />

                {/* Выровненные по правому краю элементы меню */}
                <NavLink
                    to="/products"
                    className={({ isActive }) =>
                        `font-play text-[#273167] cursor-pointer active:bg-secondary active:text-white transform transition-transform duration-200 text-sm uppercase font-bold py-3 px-4 text-right w-full ${isActive ? 'bg-secondary text-white' : ''}`
                    }
                    onClick={() => setIsMenuOpen(false)}
                >
                    Проекты
                </NavLink>
                <NavLink
                    to="/contacts"
                    className={({ isActive }) =>
                        `font-play text-[#273167] cursor-pointer active:bg-secondary active:text-white transform transition-transform duration-200 text-sm uppercase font-bold py-3 px-4 text-right w-full ${isActive ? 'bg-secondary text-white' : ''}`
                    }
                    onClick={() => setIsMenuOpen(false)}
                >
                    Контакты
                </NavLink>
            </div>
        </div>
    );
};

export default MobileNavigation;